import React from "react";
import { Button } from "antd";
import { Form } from "react-final-form";
import { SettingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import { i18, trb } from "@utilities";
import { FormField } from "../FormField";
import { routerPath } from "@config";
import { DownloadExcel } from "../Util";

import "./FilterList.less";

export const FilterList = ({ inputs, callback, onDownload, isExcelDownloading }) => {
  const onFilterList = filterValues => {
    if (callback) {
      callback(filterValues);
    }
  };

  return (
    <div className="m-2 filter-list">
      <Form
        onSubmit={onFilterList}
        render={({ handleSubmit }) => {
          return (
            <form className="my-3" id="filterList" onSubmit={handleSubmit}>
              <div className="row align-items-end">
                {inputs.map(
                  (
                    {
                      name,
                      component,
                      title,
                      optionsLabel,
                      optionsValue,
                      translate,
                      allowClear,
                      options,
                      value
                    },
                    index
                  ) => (
                    <div key={index} className="col-lg-2 col-3">
                      <FormField
                        name={name}
                        component={component}
                        title={title}
                        optionsLabel={optionsLabel || "label"}
                        optionsValue={optionsValue || "value"}
                        translate={translate}
                        allowClear={allowClear}
                        options={options}
                        defaultValue={value}
                      />
                    </div>
                  )
                )}
                <div className="d-flex align-items-end px-3 pb-3 button-container">
                  <Button htmlType="submit" type="primary">
                    {trb(i18.Buttons.Filter)}
                  </Button>
                  <div className="align-self-center">
                    <Link to={routerPath.kycApplicationsSettings}>
                      <SettingOutlined className="icon-primary" />
                    </Link>
                  </div>
                  <DownloadExcel isLoading={isExcelDownloading} handleDownload={onDownload} />
                </div>
              </div>
            </form>
          );
        }}
      />
    </div>
  );
};
